module.exports = __webpack_public_path__ + "static/img/manual-38.989746a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-38.png
// module id = sh8a
// module chunks = 4